import React from 'react';
import styles from './TextArea.module.css';

const TextArea = ({ value, onChange, label }) => {
    const handleChange = (event) => {
        onChange(event.target.value);
    };
    return (
        <div className={styles.textareaBox}>
            <div className={styles.textareaBoxHeader}>
                <span className={styles.label}>{label}</span>
                <span className={styles.label}>{value.length}/300</span>
            </div>
            <textarea
                className={styles.textarea}
                value={value}
                onChange={handleChange}
                maxLength={300}
                // placeholder="Your review"
            />
        </div>
    );
};

export default TextArea;
